import {useEffect, useRef} from 'react'

export const useInterval = (callback, delay, stop = false) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    let id = ''
    if (delay !== null && !stop) {
      id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    if (stop) {
      clearInterval(id);
    }
  }, [delay, stop]);
}

export default useInterval
